import template from './charting.template.html';

export default {
  template,
  bindings: {
    id: '<',
    type: '<',
    data: '<',
    height: '<'
  },
  controller: class controller {
    constructor(chartingService) {
      'ngInject';

      const ctrl = this;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.id = ctrl.id || '';
        ctrl.type = ctrl.type || '';
        ctrl.data = ctrl.data || {};
        ctrl.height = ctrl.height || 300;
        if (ctrl.id) {
          ctrl.prepareChart();
        }
      };

      ctrl.prepareChart = () => {
        chartingService.create({ type: ctrl.type, data: ctrl.data }).then((res) => {
          const iframe = angular.element(`#${ctrl.id}`);
          iframe[0].contentWindow.document.write(res.chart);
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
